
import Cell from '../components/Cell.js';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';

export default function Ready() {

  toast.success('Compte validé !', {
    autoClose: 2000,
  });

  return (
    <div>
        <div id='motus_title'>
          <Cell
            key={'1'}
            letter={'M'}
            status={'present'}
          />
          <Cell
            key={'2'}
            letter={'O'}
            status={'absent'}
          />
          <Cell
            key={'3'}
            letter={'M'}
            status={'present'}
          />
          <Cell
            key={'4'}
            letter={'O'}
            status={'absent'}
          />
          <Cell
            key={'5'}
            letter={'M'}
            status={'correct'}
          />
          <Cell
            key={'6'}
            letter={'O'}
            status={'correct'}
          />
          <Cell
            key={'7'}
            letter={'T'}
            status={'correct'}
          />
          <Cell
            key={'8'}
            letter={'U'}
            status={'correct'}
          />
          <Cell
            key={'9'}
            letter={'S'}
            status={'correct'}
          />
        </div>
        <div className='cleared'></div>

        <div className='margin-top-20'>
          <p>
            Votre compte a bien été vérifié, vous pouvez dès à présent <Link to="/authent/login">vous connecter</Link> pour commencer à jouer
          </p>
        </div>
    </div>
  );
}